export const ContratosActionTypes = {
    API_RESPONSE_SUCCESS: '@@contratos/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@contratos/API_RESPONSE_ERROR',

    GET_CONTRATO: '@@contratos/GET_CONTRATO',
    LIST_CONTRATOS: '@@contratos/LIST_CONTRATOS',
    CREATE_CONTRATO:'@@contratos/CREATE_CONTRATO',
    UPDATE_CONTRATO:'@@contratos/UPDATE_CONTRATO',
    DELETE_CONTRATO:'@@contratos/DELETE_CONTRATO',

    RESET: '@@contratos/RESET',
    RESET_CONTRATO: '@@contratos/RESET_CONTRATO',
};
